import log from 'loglevel';

export enum GreetingStyle {
    DEFAULT = 'default',
    QUIET = 'quiet',
    LOUD = 'loud',
}
export type GreetingTaskDefinition = {
    message: string;
    hideDelay?: number;
    style?: GreetingStyle;
    deeplink?: {
        id: string;
    };
};

export enum GreetingTaskEventType {
    DISPLAY = 'display',
    CLOSE = 'close',
    TIMEOUT = 'timeout',
    OPEN = 'open',
}
